import {Component, Inject} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {DesktopHost, EditingWorkspace} from '../../types-repository';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-mount-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">Mount {{ data.workspace.mountPoint }} ({{ data.workspace.volumeSizeGiB }} GiB)</div>
        <div class="modal-body">
          <table class="cl-table-data" style="width:100%">
            <thead>
            <tr>
              <th class="cl-table-head cl-p-tiny">Host</th>
              <th class="cl-table-head cl-p-tiny">Type</th>
              <th class="cl-table-head cl-p-tiny"></th>
            </tr>
            </thead>
            <tbody>
            @for (host of data.hosts; track host.instanceId) {
              <tr>
                <td>
                  <strong>{{ host.name || host.instanceId }}</strong>
                  <br><small class="text-muted">{{ host.instanceId }}</small>
                </td>
                <td>{{ host.instanceType }}</td>
                <td class="cl-td-links" width="1%">
                  @if (mountingHost === host.instanceId) {
                    <span class="cl-color-honey"><i class="fas fa-spinner fa-spin"></i> Mounting...</span>
                  } @else if (!mountingHost) {
                    <a class="cl-a-btn cl-a-primary" (click)="mount(host)">Mount here</a>
                  }
                </td>
              </tr>
            }
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <span class="modal-footer-left"></span>
          <span class="modal-footer-center">
            <button type="button" class="btn cl-color-primary" (click)="dialogRef.close()">
              <span>Close</span>
            </button>
          </span>
          <span class="modal-footer-right"></span>
        </div>
      </div>
    </div>
  `,
})
export class MountDialogComponent {
  mountingHost: string | null = null;

  constructor(
    public dialogRef: DialogRef<MountDialogComponent>,
    @Inject(DIALOG_DATA) public data: {
      workspace: EditingWorkspace;
      hosts: DesktopHost[];
      onMount: (host: DesktopHost, done: (success: boolean) => void) => void;
    },
  ) {}

  mount(host: DesktopHost) {
    this.mountingHost = host.instanceId;
    this.data.onMount(host, (success) => {
      if (success) {
        this.dialogRef.close();
      } else {
        this.mountingHost = null;
      }
    });
  }
}
